module.exports = __webpack_public_path__ + "img/7xiao.f616cf6f.png";